import { Component } from 'react'
import { RewardsFilter } from 'interfaces/bounty'
import { REWARD_FILTERS } from 'constants/bounty'
import { RewardDetailsTabsProps } from 'components/features/pfm/RewardDetailsTabs/RewardDetailsTabs'
import * as styles from 'components/features/pfm/RewardDetailsTabs/RewardDetailsTabsDesktop.css'
import * as cn from 'classnames'

class RewardDetailsTabsDesktop extends Component<RewardDetailsTabsProps> {
  render () {
    return (
      <div className={ styles.tabs }>
        { REWARD_FILTERS.map(this.renderTab) }
      </div>
    )
  }

  renderTab = (filter: RewardsFilter) => {
    const { active, onTabClick } = this.props
    const isActive = active === filter

    const handleClick = isActive
      ? undefined
      : () => onTabClick(filter)

    const className = cn(styles.tab, {
      [styles.active]: isActive,
    })

    return (
      <div
        key={ filter }
        data-qa-type='tab'
        data-qa-marker={ filter }
        className={ className }
        onClick={ handleClick }
      >
        { filter }
      </div>
    )
  }
}

export default RewardDetailsTabsDesktop
